import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";
import { _ } from "~/i18n";

export function showBadParamNotificationMessage() {
	Notifications.notify({
		content: _("fixedurl.badParams"),
		type: NOTIFICATIONS_TYPE.ERROR,
	});
}
